
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import ContainerBox from 'layouts/UIElements/ContainerBox/ContainerBox';
import Button from "react-bootstrap/Button";
import { withRouter } from 'helpers/ModuleHelper';
import { Flow } from 'flow-react';
import { observer } from 'mobx-react';
import * as actions from 'store/actions';
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faEllipsisH, faArrowLeft, faArrowRight }
    from '@fortawesome/free-solid-svg-icons';
import { parseStringField, checkGroupFields, sliceText } from "helpers/FieldHelper";
import * as ConfigTypes from 'config/ConfigTypes';
import { getMetaConfig } from "helpers/ConfigHelper";
import * as fieldHelper from "helpers/FieldHelper";
import { getThumbUrl, getImgUrl } from "helpers/ImageHelper";
import { onFullScreenClick } from "helpers/PageHelper";
import VideoPlayer from 'components/VideoPlayer/VideoPlayer';
import { isHome, pubPath } from 'helpers/AppHelper';
import Spinner from 'layouts/UIElements/Spinner/Spinner';
import WorkFilter from 'pages/WorkPage/WorkFilter/WorkFilter';
import { getMediaTypeObj, getDefaultImg } from 'helpers/FileHelper';
import './WorkDetail.scss';


const WorkDetail = observer(
    class WorkDetail extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                viewMode: ConfigTypes.WORK_DETAIL,
                showIntl: "workdetail.showMore"
            }
        }

        formatMessage = ({ id }) => this.props.intl.formatMessage({ id });

        updateClip = () => {
            const { currentClip } = this.props.mediaObjects;
            if (currentClip) {
                console.log("LOGS: currentClip", currentClip);
                this.setState({ currentClip: currentClip }, () => {
                    let mediaUrl = getImgUrl({ stateCurrentClip: this.state.currentClip });
                    this.setState({ mediaUrl });

                    let elements;
                    if (currentClip && currentClip.mediafiles && currentClip.mediafiles.elements) {
                        elements = currentClip.mediafiles.elements;
                    }
                    let mediaTypeObj = getMediaTypeObj({ elements, clip: currentClip });
                    console.log("LOGS: showCustomMedia mediaTypeObj", mediaTypeObj);
                    if (mediaTypeObj) {
                        this.setState({ mediaUrl: mediaTypeObj.mediaUrl, mediaTypeObj, loading: false });
                    }
                });
            }
        }

        setCurrentWork = () => {
            const { currentWork } = this.props.mediaObjects;
            let currentClip = currentWork.clips.elements[0].data;
            console.log("LOGS: WORKDETAIL currentClip", currentClip);
            let mediaUrl;
            if (currentWork && currentWork.metadata && currentWork.metadata.fields) {
                if (currentWork.metadata.fields.videourl) {
                    mediaUrl = currentWork.metadata.fields.videourl;
                    currentClip.videourl = mediaUrl;
                }
                if (currentWork.metadata.fields.thumbnail) {
                    currentClip.thumbnail = currentWork.metadata.fields.thumbnail;
                }
            }
            this.setState({ currentClip }, () => {
                if (!mediaUrl) mediaUrl = getImgUrl({ stateCurrentClip: this.state.currentClip });
                this.setState({ mediaUrl, noVideo: false });
            });

            let updated = {
                currentClip,
                openVideoPlayer: true
            };
            this.props.updateMediaObjects(updated);
        }

        setMultiMode = () => {
            const { currentWork } = this.props.mediaObjects;
            this.setState({ currentClip: currentWork }, () => {
                let mediaUrl = getImgUrl({ stateCurrentClip: this.state.currentClip });
                this.setState({ mediaUrl, noVideo: false });
            });

            let updated = {
                currentClip: currentWork,
                openVideoPlayer: true
            };
            this.props.updateMediaObjects(updated);
        }

        updateWork = () => {
            const { currentWork } = this.props.mediaObjects;
            if (currentWork) {
                if (currentWork.clips && currentWork.clips.elements
                    && currentWork.clips.elements.length) {
                    this.setCurrentWork();
                } else {
                    if (ConfigTypes.MULTI_MODE) this.setMultiMode();
                    else this.setState({ noVideo: true });
                }
                this.setState({ currentWork: currentWork });
            }
        }

        onChevClick = ({ isBack = false }) => () => {
            const { currentWork } = this.props.mediaObjects;
            if (currentWork && currentWork.id) {
                let workId = +currentWork.id;
                if (isBack) workId--;
                else workId++;
                console.log("LOGS: workId", workId);
                this.props.getWork({ workId });
                this.props.router.navigate(`${ConfigTypes.WORK_PATH}/${workId}`);
            }
        }

        onNewSearchClick = () => {
            this.props.updateMediaObjects({ viewMode: ConfigTypes.SEARCH_PAGE });
            if (!isHome()) this.props.router.navigate("/")
        }

        onLeftMenuClick = (item) => () => {
            if (item.name === ConfigTypes.OVERVIEW) {
                this.props.updateMediaObjects({ keyword: "", viewMode: ConfigTypes.HOME, currentPage: 1 });
                if (!isHome()) this.props.router.navigate("/");
            }
        }

        showLeftMenu = () => {
            return (
                <div className="workdetail-leftmenu-box">
                    {ConfigTypes.WORKDETAIL_LEFTMENU.map(item => {
                        return (
                            <div className="workdetail-leftmenu-item"
                                onClick={this.onLeftMenuClick(item)}>
                                {this.props.intl.formatMessage({ id: item.intl })}
                            </div>
                        )
                    })}
                </div>
            )
        }

        showChevron = () => {
            return (
                <Fragment>
                    <div className="workdetail-media-back" onClick={this.onChevClick({ isBack: true })}>
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </div>
                    <div className="workdetail-media-next" onClick={this.onChevClick({ isBack: false })}>
                        <FontAwesomeIcon icon={faChevronRight} />
                    </div>
                </Fragment>)
        }

        showNoVideo = () => {
            return (
                <div className="workdetail-thumb-box">
                    <div className="workdetail-thumb" >
                        <img className="img-responsive img-rounded"
                            src={`${pubPath()}/img1.jpg`} alt="" />
                        <div className="workdetail-play-box">
                            {this.props.intl.formatMessage({ id: "workdetail.novideo" })}
                        </div>
                        {this.showChevron()}
                    </div>
                </div>)
        }


        showImage = ({ isDefault }) => {
            let elementId = "workDetailImage";
            let fullSrc = getImgUrl({ fullScreen: true, stateCurrentClip: this.state.currentClip });
            if (this.state.fullMediaUrl) fullSrc = this.state.fullMediaUrl;
            let imgUrl;
            if (this.state.mediaTypeObj && this.state.mediaTypeObj.mediaUrl) {
                imgUrl = this.state.mediaTypeObj.mediaUrl;
            }
            if (isDefault) {
                imgUrl = getDefaultImg();
                fullSrc = imgUrl;
            }

            return (
                <div className="workdetail-img-box">
                    {/* {isDefault && (<div className="workdetail-img-overlay"></div>)} */}
                    <img className="workdetail-media" src={imgUrl}
                        onClick={onFullScreenClick(elementId, fullSrc)} id={elementId} />
                </div>)
        }

        showCustomMedia = () => {
            if ((!this.state.loading && this.state.currentClip && !this.props.mediaObjects.loading)
                || this.props.mediaObjects.openVideoPlayer) {
                if (this.state.mediaTypeObj && this.state.mediaTypeObj.type === ConfigTypes.VIDEO) {
                    return (
                        <div className="workdetail-media-box">
                            <VideoPlayer />
                        </div>)
                }
                if (this.state.mediaTypeObj && this.state.mediaTypeObj.type === ConfigTypes.IMAGE) {
                    return this.showImage({});
                }
                return this.showImage({ isDefault: true });
            }
        }

        showContent = ({ showFields, isDesc = false, isHeading = false, isShort, isColumn, view }) => {
            let maxLength = false;
            if (!view) view = this.state.viewMode;
            if (showFields && showFields.length) {
                const { currentWork } = this.props.mediaObjects;
                return showFields.map((item, i) => {
                    let desc = item[`${view}description`] || false;
                    let heading = item[`${view}heading`] || false;
                    let isGroup = item[`${view}group`];
                    let filterType = item[`${view}filterType`] || false;
                    let noLabelList = item[`${view}noLabelList`] || false;
                    if (isShort) maxLength = item[`${view}maxLength`] ? ConfigTypes.MAX_LENGTH : false;
                    if (heading === isHeading && isHeading) {
                        return fieldHelper.showElementMetaBox({
                            el: item, i, viewMode: view, isGroup,
                            element: currentWork, formatMessage: this.formatMessage,
                        });
                    }
                    if (desc === isDesc && isDesc) {
                        let fieldTxt = fieldHelper.parseStringField(currentWork.metadata.fields[item.field], filterType);
                        return (
                            <div className="workdetail-content">
                                {maxLength && fieldTxt ?
                                    sliceText(fieldTxt, maxLength)
                                    : fieldTxt}
                            </div>)
                    }
                    if (((desc === isDesc && !isHeading && !heading) && currentWork && currentWork.metadata
                        && currentWork.metadata.fields && currentWork.metadata.fields[item.field])
                        || (isGroup)) {
                        let boxClass = "workdetail-content-box";
                        let labelClass = "workdetail-label";
                        if (isColumn) {
                            boxClass = "workdetail-column-box";
                            labelClass = "workdetail-column-label"
                        }
                        return fieldHelper.showElementMetaBox({
                            el: item, i, viewMode: view,
                            element: currentWork, formatMessage: this.formatMessage,
                            boxClass, isGroup, labelClass, txtClass: "workdetail-content",
                            filterType, maxLength, noLabelList
                        });
                    }
                })
            }
        }

        toggleShowBtn = () => {
            let showIntl = "workdetail.showMore";
            if (!this.state.showMore) showIntl = "workdetail.showLess";
            this.setState({ showMore: !this.state.showMore, showIntl });
        }

        showRight = ({ showFields }) => {
            return (
                <div>
                    {this.showContent({ showFields, isShort: true })}
                    <div className="workdetail-btn-wrapper">
                        <Button variant="dark" onClick={this.toggleShowBtn}
                            className="workdetail-btn-showmore" >
                            {this.props.intl.formatMessage({ id: this.state.showIntl })}
                            <span className="workdetail-search-icon">
                                <FontAwesomeIcon icon={faEllipsisH} />
                            </span>
                        </Button>
                    </div>
                </div>)
        }

        showLongDetails = () => {
            let view = ConfigTypes.WORK_DETAIL_LONG;
            const showFields = getMetaConfig({ viewMode: view, props: this.props, configName: ConfigTypes.WORK });
            let firstColumn = showFields.filter(field => field[`${view}column`] && field[`${view}column`] == 1);
            let secondColumn = showFields.filter(field => field[`${view}column`] && field[`${view}column`] == 2);
            let thirdColumn = showFields.filter(field => field[`${view}column`] && field[`${view}column`] == 3)
            if ((firstColumn && firstColumn.length) || (secondColumn && secondColumn.length) || (thirdColumn && thirdColumn.length)) {
                return (
                    <div className="workdetail-long-wrapper">
                        <div className="col-sm-12 col-md-2">
                            {this.showContent({ showFields: firstColumn, isColumn: true, view })}
                        </div>
                        <div className="col-sm-12 col-md-3">
                            {this.showContent({ showFields: secondColumn, isColumn: true, view })}
                        </div>
                        <div className="col-sm-12 col-md-6">
                            {this.showContent({ showFields: thirdColumn, isColumn: true, view })}
                        </div>
                    </div>)
            }
            return (<div>{this.showContent({ showFields, view })}</div>)
        }

        showBottom = () => {
            return (<WorkFilter showMore={this.state.showMore}
                showLongDetails={this.showLongDetails} />)
        }


        getPrevNextWork = (isNext = true) => {
            const { worklist, currentWork } = this.props.mediaObjects;
            let nextIndex;
            let nextWork;
            let nextCount = 1;
            if (!isNext) nextCount = -1;
            if (worklist && worklist.length) {
                const workIndex = worklist.findIndex(work => +work.id === +currentWork.id);
                if (workIndex > -1) {
                    nextIndex = workIndex + nextCount;
                    nextWork = worklist[nextIndex];
                    if (nextWork && nextWork.id) {
                        let nextWorkId = nextWork.id;
                        //let nextWorkId = 4383;
                        this.props.updateMediaObjects({ viewMode: ConfigTypes.WORK_DETAIL, toTop: true });
                        this.props.getWork({ workId: nextWorkId });
                        this.props.router.navigate(`${ConfigTypes.WORK_PATH}/${nextWorkId}`);
                    }
                }
            }
        }

        onNextClick = () => {
            this.getPrevNextWork();
        }

        onPrevClick = () => {
            this.getPrevNextWork(false);
        }

        onBackClick = () => {
            this.props.updateMediaObjects({ viewMode: ConfigTypes.LIST, toTop: true });
            if (!isHome()) this.props.router.navigate("/");
        }

        showBackNextBtn = () => {
            return (
                <div className="workdetail-navbtns">
                    <div className="workdetail-back" onClick={this.onBackClick}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                        {this.props.intl.formatMessage({ id: "searchfilter.showback" })}
                    </div>
                    <div className="workdetail-prev" onClick={this.onPrevClick}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                        {this.props.intl.formatMessage({ id: "searchfilter.showprev" })}
                    </div>
                    <div className="workdetail-next" onClick={this.onNextClick}>
                        {this.props.intl.formatMessage({ id: "searchfilter.shownext" })}
                        <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                </div>)
        }

        showWorkDetail = () => {
            const showFields = getMetaConfig({ viewMode: this.state.viewMode, props: this.props, configName: ConfigTypes.WORK });
            if (this.state.currentWork && this.state.currentWork.metadata
                && this.state.currentWork.metadata.fields && showFields) {
                return (
                    <div className="workdetail-container">
                        <div className="workdetail-top">
                            {this.showBackNextBtn()}
                        </div>
                        <div className="workdetail-body">
                            <div className="workdetail-left">
                                {this.showCustomMedia()}
                            </div>
                            <div className="workdetail-right">
                                {this.showRight({ showFields })}
                            </div>
                        </div>
                        <div className="workdetail-bottom">
                            {this.showBottom()}
                        </div>
                        <div className="workdetail-footer">
                        </div>
                    </div>
                )
            }
        }

        componentDidUpdate(prev) {
            if (prev.mediaObjects.currentWork != this.props.mediaObjects.currentWork) {
                this.updateWork();
            }

            if (prev.mediaObjects.currentClip != this.props.mediaObjects.currentClip) {
                this.updateClip();
            }
        }

        componentDidMount() {
            this.updateWork();
        }

        render() {
            return (
                <ContainerBox>
                    <div className="workdetail">
                        {this.showWorkDetail()}
                    </div>
                    {this.props.loading && (
                        <div className="searchlist-overlay">
                            <Spinner />
                        </div>)}
                </ContainerBox>)
        }
    }
)

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects,
    loading: state.media.mediaObjects.loading,
    configObjects: state.config.configObjects,
    cartObjects: state.cart.cartObjects,
});

const mapDispatchToProps = (dispatch) => ({
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    updateAppObjects: (obj) => dispatch(actions.updateAppObjects(obj)),
    getWork: (data) => dispatch(actions.getWork(data)),
    updateCartObjects: (obj) => dispatch(actions.updateCartObjects(obj)),
})

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(WorkDetail))));